module.exports = __webpack_public_path__ + "static/img/cn.a70abb31.png";